<template>
    <div>
        <b-modal hide-footer size="xl" title="Details Kostennote"
            :visible="isModalOpen" @hide="reset" @show="loadFee">
            <div v-if="isLoading" class="d-flex justify-content-center pt-1">
                <csp-loading-indicator/>
            </div>
            <div v-else>
                <b-card class="mb-4 info-card">
                    <b-row>
                        <b-col v-for="(value, key) in fee" :key="key" cols="4">
                            <div class="info-card-element">
                                <label>
                                    {{ labels[key] || key }}
                                </label>
                                <div class="value">
                                    {{ formatters[key] ? formatters[key](value) : value }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
                <div v-if="payments.length > 0">
                    <hr>
                    <h2 class="mb-4">
                        Zahlungen
                    </h2>
                </div>
                <b-card v-for="payment in payments" :key="payment.id" class="info-card">
                    <b-button
                        v-if="payment.meta.permissions.canDelete"
                        class="float-right"
                        size="sm"
                        variant="primary"
                        @click="deletePayment(payment.id)">
                        Löschen
                    </b-button>
                    <b-row>
                        <b-col v-for="(value, key) in payment.attributes" :key="key" cols="4">
                            <div class="info-card-element">
                                <label>
                                    {{ labels[key] || key }}
                                </label>
                                <div class="value">
                                    {{ formatters[key] ? formatters[key](value) : value }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <hr>
                </b-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import {formatDate, formatDateTime} from '@js/functions/date';
    import {formatCurrencyCents, formatPercentage} from '@js/functions/format';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();
    const flashMessenger = container.getFlashMessenger();

    export default {
        name: 'FeeDetailModal',
        props: {
            feeId: {
                type: Number,
                default: null,
            },
            isModalOpen: {
                type: Boolean,
                default: false,
            },
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['close', 'updated'],
        data() {
            return {
                fee: {},
                payments: [],
                isLoading: true,
                labels: {
                    receipt: 'Beleg Nr.',
                    feeText: 'Bezeichnung',
                    amountNet: 'Forderung (netto)',
                    amountGross: 'Forderung (brutto)',
                    vatPercent: 'USt.',
                    amountVat: 'USt. Betrag',
                    paidNet: 'Eingegangen (netto)',
                    paidGross: 'Eingegangen (brutto)',
                    datePaid: 'bezahlt am',
                    amountAdjustmentNet: 'Teil- / Gutschrift (netto)',
                    amountAdjustmentGross: 'Teil- / Gutschrift (brutto)',
                    openNet: 'Offen (netto)',
                    openGross: 'Offen (brutto)',
                    dateReceipt: 'beziffert am',
                    paymentComment: 'Bemerkung',
                    creatorUserName: 'Hinzugefügt von',
                    dateSet: 'Erstellungsdatum',
                    dateUpdated: 'Letzte Änderung',
                    paymentType: 'Art der Zahlung',
                    amountPaidGross: 'Eingegangen',
                    description: 'Bemerkung',
                },
                formatters: {
                    datePaid: formatDate,
                    dateReceipt: formatDate,
                    dateSet: formatDateTime,
                    dateUpdated: formatDateTime,
                    amountNet: formatCurrencyCents,
                    amountGross: formatCurrencyCents,
                    amountVat: formatCurrencyCents,
                    paidNet: formatCurrencyCents,
                    paidGross: formatCurrencyCents,
                    amountAdjustmentNet: formatCurrencyCents,
                    amountAdjustmentGross: formatCurrencyCents,
                    openNet: formatCurrencyCents,
                    openGross: formatCurrencyCents,
                    amountPaidGross: formatCurrencyCents,
                    vatPercent: formatPercentage,
                },
            };
        },
        methods: {
            loadFee() {
                this.isLoading = true;
                recordRepository.loadFeeDetail(this.feeId, this.recordId).then(
                    (success) => {
                        this.fee = success.data.attributes;
                        this.payments = success.data.attributes.payments.data;
                        // Remove payments from fee so that they are not displayed with base data
                        delete this.fee.payments;
                    }
                ).finally(() => {
                    this.isLoading = false;
                });
            },
            reset() {
                this.fee = null;
                this.isLoading = true;
                this.$emit('close');
            },
            deletePayment(paymentId) {
                if (!confirm('Möchten Sie diese Zahlung wirklich löschen?')) {
                    return;
                }

                this.isLoading = true;
                recordRepository.deleteFeePayment(this.recordId, this.feeId, paymentId)
                    .then(() => {
                        flashMessenger.addSuccess('Zahlung erfolgreich gelöscht.');
                        this.$emit('updated');
                        this.loadFee();
                    }).finally(() => {
                        this.isLoading = false;
                    });
            },
        },
    }
</script>
